// extracted by mini-css-extract-plugin
export var backdropBlur = "_lc-0";
export var contentCard = "_lc-5";
export var frame = "_lc-2";
export var image = "_lc-4";
export var imagePane = "_lc-3";
export var modal = "_lc-1";